import {combineReducers} from 'redux';

import qcMedia from '../../VideoAudioQC/QCMedia/Redux/QCMediaReducer';
import accuratePlayer from '../../VideoAudioQC/AccuratePlayer/Redux/AccuratePlayerReducer';
import qcTabs from '../../VideoAudioQC/QCTabs/Redux/QCTabsReducer';
import qcSnapshots from '../../VideoAudioQC/QCTabs/Snapshots/Redux/SnapshotReducer';

const videoAudioQCStore = combineReducers({
    qcMedia,
    accuratePlayer,
    qcTabs,
    qcSnapshots,
});

export default videoAudioQCStore;
